import React from 'react';

function Logo({ className = "" }) {
  return (
    <svg 
      width="40" 
      height="40" 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor: '#ec4899', stopOpacity: 1}} />
          <stop offset="50%" style={{stopColor: '#a855f7', stopOpacity: 1}} />
          <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
        </linearGradient>
      </defs>
      {/* Outer circle */}
      <circle cx="20" cy="20" r="18" fill="url(#logoGradient)" opacity="0.2"/>
      {/* Middle circle */}
      <circle cx="20" cy="20" r="12" fill="url(#logoGradient)" opacity="0.4"/>
      {/* Inner circle */}
      <circle cx="20" cy="20" r="6" fill="url(#logoGradient)"/>
      {/* Decorative rings */}
      <circle cx="20" cy="8" r="2" fill="url(#logoGradient)"/>
      <circle cx="32" cy="20" r="2" fill="url(#logoGradient)"/>
      <circle cx="20" cy="32" r="2" fill="url(#logoGradient)"/>
      <circle cx="8" cy="20" r="2" fill="url(#logoGradient)"/>
    </svg>
  );
}

export default Logo;


